import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { VinService } from '../vin.service';
import { VinDetail } from '../customItem';

@Component({
  selector: 'app-vin',
  templateUrl: './vin.component.html',
  styleUrls: ['./vin.component.css']
})

export class VinComponent implements OnInit {
  vinNumber = "";
  datas: VinDetail[] = [];
  isLoading = false;
  errorMsg = "";
  vinStrs: string[] = [];
  constructor(
    private router: Router,
    private vinSv: VinService) {
    var isLogin = localStorage.getItem('isLogin');
    if (isLogin != 'true' || isLogin == null) {
      this.router.navigate(['/login']);
    }
  }


  ngOnInit() {
  }

  handleFileInput(files: FileList) {
    this.isLoading = true;
    let reader = new FileReader();
    reader.readAsDataURL(files.item(0));
    reader.onload = (data) => {
      this.vinSv.readVin(reader.result).subscribe((strs) => {
        if (strs.length > 0) {
          this.vinStrs = strs;
          this.errorMsg = "";
        } else {
          this.errorMsg = "Can not read Vin. Please upload again.";
        }
        this.isLoading = false;
      });
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  select(vin: string) {
    this.vinNumber = vin;
    this.vinStrs = [];
  }

  clear() {
    this.datas = [];
    this.vinNumber = "";
  }

  decode() {
    this.isLoading = true;
    this.vinSv.decode(this.vinNumber).subscribe(dat => {
      if (dat.isFound) {
        this.errorMsg = "";
        var props = Object.getOwnPropertyNames(dat.vinData);
        for (let i = 0; i < props.length; i++) {
          let prop = props[i];
          let value = dat.vinData[prop];
          if (value != "") {
            this.datas.push({
              Name: prop.toUpperCase(),
              Value: value.toString().toUpperCase()
            });
          }
        }
      } else {
        this.errorMsg = "Can not decode this Vin.";
      }
      this.isLoading = false;
    })
  }
}
